/*global google*/
import React, { useEffect, useState } from 'react'
import MapInfoWindowContent from './MapInfoWindowContent'
import { getInfoWindowOptions } from '../utils'
import { useTranslation } from 'react-i18next'
import { MapInfoWindowProps } from './types'
import * as ReactDOMServer from 'react-dom/server'
import LoadingIndicator from '../../Shared/Components/LoadingIndicator'

const MapInfoWindow = (props: MapInfoWindowProps) => {
    const { t } = useTranslation();
    const [infoWindow, setInfoWindow] = useState<
        google.maps.InfoWindow | undefined
    >(undefined);

    const onCloseHandler = () => {
        props.closeInfoWindow();
    }

    useEffect(() => {
        const options = getInfoWindowOptions()
        const infoWindowRef = new google.maps.InfoWindow({
            position: { lat: 0, lng: 0 },
            content: '',
            maxWidth: options.maxWidth,
            pixelOffset: options.pixelOffset,
        });
        const closeListener = google.maps.event.addListener(
            infoWindowRef,
            'closeclick',
            onCloseHandler
        );
        setInfoWindow(infoWindowRef);
        return () => {
            closeListener.remove()
        };
    }, []);

    useEffect(() => {
        if (props.open && props.map) {
            const options = getInfoWindowOptions();
            infoWindow?.open(props.map);
            infoWindow?.setOptions(options);
        } else if (!props.open) {
            infoWindow?.close();
        }
    }, [props.open]);
    
    useEffect(() => {
        const station = props.station;
        if (station) {
            infoWindow?.setPosition({
                lat: Number(station.lat),
                lng: Number(station.lng),
            });
        }
    }, [props.station]);

    useEffect(() => {
        if (props.stationDetails) {
            const content = ReactDOMServer.renderToString(
                <MapInfoWindowContent
                    idPrefix={props.idPrefix}
                    station={props.station}
                    stationDetails={props.stationDetails}
                />
            );
            infoWindow?.setContent(content);
            const infoModalLinkContainer = document.getElementById(
                `${props.idPrefix}more-info-modal-link-container`
            );
            const closeButton = document.getElementById(
                `${props.idPrefix}pexmap-infowindow-close-btn`
            );
            closeButton?.addEventListener('click', onCloseHandler);
            infoModalLinkContainer?.insertAdjacentHTML(
                'beforeend',
                `<span role="link" tabindex="0" onclick="document.getElementById('${
                    props.idPrefix
                }map-open-options-modal-link').click()">${t(
                    'recyclingStations.moreInfo'
                )}</span>`
            );
        }
    }, [props.stationDetails]);

    useEffect(() => {
        if (props.loading) {
            const content = ReactDOMServer.renderToString(
                <LoadingIndicator customMargins="5rem 0" />
            )
            infoWindow?.setContent(content)
        }
    }, [props.loading]);

    return <></>;
}

export default MapInfoWindow;
